import { loadStripe } from "@stripe/stripe-js"

import { CONST } from "@/constants"

export const getClientStripe = async () => {
  return loadStripe(CONST.ENV_STRIPE_PUBLISHABLE_KEY())
}
